//
// AUTH
export const AUTH_ERROR = "❌ AUTH_ERROR";
export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "✅ AUTH_SUCCESS";
export const LOGOUT = "👋🏻 LOGOUT";
export const REMOVE_TOKEN = "REMOVE_TOKEN";
export const REMOVE_USER = "REMOVE_USER";
export const SET_TOKEN = "SET_TOKEN";
//
// HEADERS
export const DELETE_HEADER = "DELETE_HEADER";
export const SET_HEADERS = "SET_HEADERS";
//
// INVOICES
export const SET_INVOICES = "SET_INVOICES";
//
// PROJECTS
export const ADD_PROJECT = "ADD_PROJECT";
export const SET_ACTIVE_FILTER = "SET_ACTIVE_FILTER";
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
//
// QUEUE
export const SET_QUEUE_BUSY = "SET_QUEUE_BUSY";
//
// REQUESTS
export const ADD_REQUEST_RESULT = "ADD_REQUEST_RESULT";
export const ADD_REQUESTS = "ADD_REQUESTS";
export const CLEAR_REQUESTS = "CLEAR_REQUESTS";
export const DELETE_REQUEST = "DELETE_REQUEST";
export const SET_ACTIVE_REQUEST_ID = "SET_ACTIVE_REQUEST_ID";
export const SET_REQUEST_PENDING = "SET_REQUEST_PENDING";
export const SET_REQUEST_READY = "SET_REQUEST_READY";
export const UPDATE_URL = "UPDATE_URL";
//
// SETTINGS
export const SET_HTTP_METHOD = "SET_HTTP_METHOD";
export const SET_USER_SETTINGS = "SET_USER_SETTINGS";
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";
//
// SUBSCRIPTIONS
export const SET_SUBSCRIPTIONS = "SET_SUBSCRIPTIONS";
export const SET_SUBSCRIPTION_PLAN_PRICING = "SET_SUBSCRIPTION_PLAN_PRICING";
//
// USER
export const SET_USER = "SET_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_EMAIL = "UPDATE_EMAIL";
